<template>
  <div v-if="containers" data-structure="structure">
    <FeeUnitBlock v-for="container in containers" :key="container.title+'-'+container.order"
      :groupTitle="container.title" :container="container"
      :location="location+'>'+container.title+'-'+container.order"
      :seenUnits="seenUnits"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { dynamicSort } from 'common/helpers/dynamic-sort.js'
import FeeUnitBlock from './FeeUnitBlock.vue'

export default {
  name: 'FeeStructure',
  data: function () {
    return {
      seenUnits: []
    }
  },
  props: {
    structure: {
      type: Object,
      required: true
    },
    location: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({}),
    containers: function () {
      return this.structure.containers.sort(dynamicSort('order'))
    }
  },
  methods: {
  },
  watch: {},
  components: { FeeUnitBlock }
}
</script>

